import {BaseRequestOptions, Headers} from '@angular/http';
 
export class AuthorisedRequest extends BaseRequestOptions {
    constructor() {
        super();
        if (sessionStorage.getItem("token")) {
            this.headers.append("Authorization", "Bearer " + JSON.stringify(sessionStorage.getItem("token")));
        }        
    }    
}


// WEBPACK FOOTER //
// ./client/app/models/authorisedRequest.ts